import {EntityType, ReferenceBookType} from '@npck/af-frontend-api';

export const LINK_FIELDS: Partial<Record<EntityType, string[]>> = {
    [EntityType.REFUND]: ['incidentId'],
    [EntityType.TRANSACTION]: ['incidentId'],
    [EntityType.PARTICIPANT]: ['incidentId', 'refundId', 'transactionId', 'subjectId', 'msisdnId', 'accountId', 'foreignAccountId'],
    [EntityType.RESOLUTION]: ['incidentId'],
    [EntityType.RELATED_ORGANIZATION]: ['incidentId'],
    [EntityType.CONTACT_DETAILS]: ['incidentId', 'subjectId', 'msisdnId'],
    [EntityType.MSISDN_FRAUD_ENTRY]: ['incidentId', 'msisdnId'],
    [EntityType.ACCOUNT_CARD]: ['subjectId', 'participantId'],
    [EntityType.WALLET]: ['subjectId', 'participantId'],
    [EntityType.PAYMENT_POINT]: ['subjectId', 'participantId'],
    [EntityType.MERCHANT]: ['participantId'],
    [EntityType.LOAN]: ['participantId'],
    [EntityType.TREND_FEEDBACK]: ['trendId'],
    [EntityType.TREND_STATISTIC]: ['trendId'],
};

export const IGNORED_FIELDS = new Set<string>([
    'id', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'deletedBy', 'deletedDate',
    'additionalData',
]);

export const FIELD_DICTIONARY: Record<string, string> = {
    'INCIDENT.status': ReferenceBookType.INCIDENT_STATUS,
    'INCIDENT.type': ReferenceBookType.INCIDENT_TYPE,
    'INCIDENT.fraudType': ReferenceBookType.FRAUD_TYPE,
    'INCIDENT.initialSubtype': ReferenceBookType.FRAUD_TYPE,
    'INCIDENT.basedOn': ReferenceBookType.BASED_ON,
    'INCIDENT.deletedBase': ReferenceBookType.DELETED_BASED,
    'INCIDENT.refundStatus': ReferenceBookType.INCIDENT_REFUND_STATUS,
    'INCIDENT.currency': ReferenceBookType.CURRENCY,
    'INCIDENT.currencyAmountLossCredit': ReferenceBookType.CURRENCY,
    'INCIDENT.currencyAmountLossOwn': ReferenceBookType.CURRENCY,
    'INCIDENT.currencyAmountSaveCredit': ReferenceBookType.CURRENCY,
    'INCIDENT.currencyAmountSaveOwn': ReferenceBookType.CURRENCY,
    'INCIDENT.createdByOrganization': ReferenceBookType.BIN,

    'REFUND.status': ReferenceBookType.REFUND_STATUS,
    'REFUND.type': ReferenceBookType.REFUND_TYPE,
    'REFUND.transactionType': ReferenceBookType.TRANSACTION_TYPE,
    'REFUND.grounds': ReferenceBookType.REFUND_GROUNDS,
    'REFUND.rejectType': ReferenceBookType.REJECT_TYPE,
    'REFUND.transactionCurrency': ReferenceBookType.CURRENCY,
    'REFUND.resolutionCurrency': ReferenceBookType.CURRENCY,
    'REFUND.initiatorBin': ReferenceBookType.BIN,
    'REFUND.senderBin': ReferenceBookType.BIN,
    'REFUND.receiverBin': ReferenceBookType.BIN,
    'REFUND.processingBin': ReferenceBookType.BIN,
    'REFUND.rejectedBin': ReferenceBookType.BIN,
    'REFUND.prosecutorOfficeBin': ReferenceBookType.BIN,

    'PARTICIPANT.subjectType': 'subject_type',
    'PARTICIPANT.country': ReferenceBookType.COUNTRY,
    'PARTICIPANT.gender': ReferenceBookType.GENDER,

    'TRANSACTION.type': ReferenceBookType.TRANSACTION_TYPE,
    'TRANSACTION.status': ReferenceBookType.TRANSACTION_STATUS,
    'TRANSACTION.currency': ReferenceBookType.CURRENCY,
    'TRANSACTION.channel': ReferenceBookType.TRANSACTION_CHANNEL,
    'TRANSACTION.fraudScheme': ReferenceBookType.FRAUD_SCHEME,
    'TRANSACTION.completionStatus': ReferenceBookType.TRANSACTION_COMPLETION_STATUS,
    'TRANSACTION.createdByOrganization': ReferenceBookType.BIN,

    'SUBJECT.type': 'subject_type',
    'SUBJECT.country': ReferenceBookType.COUNTRY,
    'SUBJECT.gender': ReferenceBookType.GENDER,
    'SUBJECT.organizationType': ReferenceBookType.ORG_TYPE,
    'SUBJECT.createdByOrganization': ReferenceBookType.BIN,

    'SUBJECT_CATEGORY.type': ReferenceBookType.CATEGORY,
    'SUBJECT_CATEGORY.createdByOrganization': ReferenceBookType.BIN,
    'SUBJECT_CATEGORY.creationReason': ReferenceBookType.SUBJECT_CREATION_REASON,
    'SUBJECT_CATEGORY.deletionReason': ReferenceBookType.DELETED_BASED,

    'RESOLUTION.bin': ReferenceBookType.BIN,
    'RESOLUTION.status': ReferenceBookType.INCIDENT_STATUS,

    'RELATED_ORGANIZATION.bin': ReferenceBookType.BIN,
    'RELATED_ORGANIZATION.governmentBin': ReferenceBookType.BIN,

    'CONTACT_DETAILS.contactType': ReferenceBookType.CONTACT_TYPE,
    'CONTACT_DETAILS.contactTimeframe': ReferenceBookType.CONTACT_TIMEFRAME,
    'CONTACT_DETAILS.callContactType': ReferenceBookType.CALL_CONTACT_TYPE,
    'CONTACT_DETAILS.messengerContactType': ReferenceBookType.MESSENGER_CONTACT_TYPE,
    'CONTACT_DETAILS.messengerContactSubtype': ReferenceBookType.MESSENGER_CONTACT_SUBTYPE,
    'CONTACT_DETAILS.emailContactType': ReferenceBookType.EMAIL_CONTACT_TYPE,
    'CONTACT_DETAILS.socialContactType': ReferenceBookType.SOCIAL_CONTACT_TYPE,
    'CONTACT_DETAILS.internetContactType': ReferenceBookType.INTERNET_CONTACT_TYPE,
    'CONTACT_DETAILS.contactReason': ReferenceBookType.CONTACT_REASON,
    'CONTACT_DETAILS.fraudsterRole': ReferenceBookType.FRAUDSTER_ROLE,
    'CONTACT_DETAILS.status': ReferenceBookType.MSISDN_STATUS,
    'CONTACT_DETAILS.victimActions': ReferenceBookType.VICTIM_ACTION,
    'CONTACT_DETAILS.createdByOrganization': ReferenceBookType.BIN,

    'MSISDN_FRAUD_ENTRY.operator': ReferenceBookType.MOBILE_OPERATOR,
    'MSISDN_FRAUD_ENTRY.status': ReferenceBookType.MSISDN_STATUS,
    'MSISDN_FRAUD_ENTRY.reason': ReferenceBookType.MOBILE_OPERATOR_EVENT_SOURCE,
    'MSISDN_FRAUD_ENTRY.category': ReferenceBookType.SUBSCRIBER_CATEGORY,
    'MSISDN_FRAUD_ENTRY.country': ReferenceBookType.COUNTRY,

    'ACCOUNT.status': ReferenceBookType.ACCOUNT_STATUS,
    'ACCOUNT.currency': ReferenceBookType.CURRENCY,
    'ACCOUNT.issuerBin': ReferenceBookType.BIN,

    'FOREIGN_ACCOUNT.status': ReferenceBookType.ACCOUNT_STATUS,
    'FOREIGN_ACCOUNT.currency': ReferenceBookType.CURRENCY,

    'ACCOUNT_CARD.issuerBin': ReferenceBookType.BIN,

    'WALLET.issuerBin': ReferenceBookType.BIN,

    'PAYMENT_POINT.issuerBin': ReferenceBookType.BIN,

    'MERCHANT.categoryCode': ReferenceBookType.MERCHANT_CATEGORY_CODE,

    'LOAN.type': ReferenceBookType.LOAN_TYPE,
    'LOAN.status': ReferenceBookType.LOAN_STATUS,
    'LOAN.borrowerCategory': ReferenceBookType.BORROWER_CATEGORY,
    'LOAN.amountCurrency': ReferenceBookType.CURRENCY,
    'LOAN.balanceCurrency': ReferenceBookType.CURRENCY,
    'LOAN.forgivenessCurrency': ReferenceBookType.CURRENCY,

    'TREND.type': ReferenceBookType.TREND_TYPE,
    'TREND.status': ReferenceBookType.TREND_STATUS,
    'TREND.source': ReferenceBookType.SOURCE_TYPE,
    'TREND.fraudType': ReferenceBookType.FRAUD_TYPE,

    'FRAUD_REPORT.reportStatus': ReferenceBookType.FRAUD_REPORT_STATUS,
    'FRAUD_REPORT.reportType': ReferenceBookType.FRAUD_REPORT_TYPE,
};
